<ng-container *ngIf="data !== undefined; else singleInputs">
  <div class="submenu-item" (click)="onItemClicked()" [ngClass]="{'locked': isUnavailable}" *ngIf="data.clickCallback; else linkItems" (mouseenter)="onMouseEnterEvent()" (mouseleave)="onMouseLeaveEvent()" [tabindex]="canFocus ? 0 : -1">
    <div class="submenu-item__left">
      <img [src]="data.iconUrl" alt="" *ngIf="iconType === 'img'; else lottieAnimationBlankLink">
      <ng-template #lottieAnimationBlankLink>
        <brt-lottie [lottieOptions]="{path: data.iconUrl, loop: false, autoplay: false}" (instanceCreated)="onAnimationCreated($event)"></brt-lottie>
      </ng-template>
    </div>
    <div class="submenu-item__right">
      <div class="submenu-item__title" [innerHTML]="data.title"></div>
      <div class="submenu-item__abstract" [innerHTML]="data.abstract"></div>
      <div class="submenu-item__tags" *ngIf="data.tags.length > 0">
        <brt-item-tag [data]="itemTag" *ngFor="let itemTag of data.tags"></brt-item-tag>
      </div>
    </div>
  </div>
  <ng-template #linkItems>
    <a [href]="data.link" [target]="data.target" class="submenu-item" *ngIf="data.target === '_blank'; else routerLinkTemplate" (mouseenter)="onMouseEnterEvent()" (mouseleave)="onMouseLeaveEvent()" [tabindex]="canFocus ? 0 : -1">
      <div class="submenu-item__left">
        <img [src]="data.iconUrl" alt="" *ngIf="iconType === 'img'; else lottieAnimationBlankLink">
        <ng-template #lottieAnimationBlankLink>
          <brt-lottie [lottieOptions]="{path: data.iconUrl, loop: false, autoplay: false}" (instanceCreated)="onAnimationCreated($event)"></brt-lottie>
        </ng-template>
      </div>
      <div class="submenu-item__right">
        <div class="submenu-item__title" [innerHTML]="data.title"></div>
        <div class="submenu-item__abstract" [innerHTML]="data.abstract"></div>
        <div class="submenu-item__tags" *ngIf="data.tags.length > 0">
          <brt-item-tag [data]="itemTag" *ngFor="let itemTag of data.tags"></brt-item-tag>
        </div>
      </div>
    </a>
    <ng-template #routerLinkTemplate>
      <a [routerLink]="data.link" [target]="data.target" class="submenu-item" (mouseenter)="onMouseEnterEvent()" (mouseleave)="onMouseLeaveEvent()" [tabindex]="canFocus ? 0 : -1">
        <div class="submenu-item__left">
          <img [src]="data.iconUrl" alt="" *ngIf="iconType === 'img'; else lottieAnimationRouterLink">
          <ng-template #lottieAnimationRouterLink>
            <brt-lottie [lottieOptions]="{path: data.iconUrl, loop: false, autoplay: false}" (instanceCreated)="onAnimationCreated($event)"></brt-lottie>
          </ng-template>
        </div>
        <div class="submenu-item__right">
          <div class="submenu-item__title" [innerHTML]="data.title"></div>
          <div class="submenu-item__abstract" [innerHTML]="data.abstract"></div>
          <div class="submenu-item__tags" *ngIf="data.tags.length > 0">
            <brt-item-tag [data]="itemTag" *ngFor="let itemTag of data.tags"></brt-item-tag>
          </div>
        </div>
      </a>
    </ng-template>
  </ng-template>

</ng-container>
<ng-template #singleInputs>
  <a [href]="link" [target]="target" class="submenu-item" *ngIf="target === '_blank'; else routerLinkTemplate" [tabindex]="canFocus ? 0 : -1">
    <div class="submenu-item__left">
      <img [src]="iconUrl" alt="">
    </div>
    <div class="submenu-item__right">
      <div class="submenu-item__title" [innerHTML]="title">

      </div>
      <div class="submenu-item__abstract" [innerHTML]="abstract">

      </div>
    </div>
  </a>
  <ng-template #routerLinkTemplate>
    <a [routerLink]="link" [target]="target" class="submenu-item" [tabindex]="canFocus ? 0 : -1">
      <div class="submenu-item__left">
        <img [src]="iconUrl" alt="">
      </div>
      <div class="submenu-item__right">
        <div class="submenu-item__title" [innerHTML]="title">

        </div>
        <div class="submenu-item__abstract" [innerHTML]="abstract">

        </div>
      </div>
    </a>
  </ng-template>
</ng-template>

